import React, { useContext, useEffect, useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Button, Form, UncontrolledTooltip } from "reactstrap";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { Input } from "../../ui/input";
import { preventFormSubmitOnEnter } from "../../../_helpers/utils";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { useDispatch, useSelector } from "react-redux";
import { toggleNavigation } from "../../../store/actions/documentActions";

let style = Object.assign({}, global);

const BlockTileModal = props => {
  const dispatch = useDispatch();

  let { blockNodes, metadata, updateBlockNodes } = useContext(EditorContext);

  const { documentDetails } = useSelector(state => state?.document);

  const documentId = documentDetails?.data?.id;
  const maxLength = 50;

  const [blockTileValue, setBlockTileValue] = useState();
  const [charCount, setCharCount] = useState(0);

  const checkValidity = e => {
    setCharCount(e.target.value.trim().length);

    if (e.target.value !== "") setBlockTileValue(e.target.value);
    else setBlockTileValue("");
  };

  const applyBlockTitle = () => {
    let newArray = Object.assign([...blockNodes], {
      [metadata.activeBlockIdx]: {
        ...blockNodes[metadata.activeBlockIdx],
        blockName: blockTileValue.replace(/^\s+|\s+$/g, ""),
      },
    });

    updateBlockNodes(newArray);

    //if show menu is on then off the toggle if after update there is no block title
    let isupdateApi = true;
    for (const item of newArray) {
      if (item.blockName) {
        isupdateApi = false;
        break;
      }
    }

    if (isupdateApi) {
      let payload = {
        document_id: documentId,
        navigation: false,
      };

      dispatch(toggleNavigation(payload));
    }

    props.setShowModal(!props.showModal);
  };

  useEffect(() => {
    setBlockTileValue(blockNodes[metadata.activeBlockIdx]?.blockName);
    if (blockNodes[metadata.activeBlockIdx]?.blockName)
      setCharCount(blockNodes[metadata.activeBlockIdx]?.blockName.replace(/\s/g, "").length);
  }, []);

  return (
    <>
      <div className={cx(style["d-flex"], style["align-items-center"], style["mb-4"], style["modal-heading"])}>
        <h4 className={cx(style["fw-7"], style["mb-0"])}>Block Title</h4>
        <div className={cx(style["cursor-pointer"], style["custom-tooltip"], style["d-flex"], style["ml-2"])}>
          <Icon icon="ui-info" additionalclass="font-base" />
          <span className={cx(style["custom-tooltip-content"], style["bottom"], style["text-center"])}>
            Block Title is displayed in the <br></br> navigation menu in the published page
          </span>
        </div>
      </div>

      <span className={cx(style["cross-modal"], style["rounded"])} onClick={() => props.setShowModal(!props.showModal)}>
        <Icon icon="ui-close" />
      </span>

      <Form id="blockTileForm" onKeyDown={e => preventFormSubmitOnEnter(e)}>
        <div className={cx(style["form-group"], style["mb-3"])}>
          <div className="block-tile-field clearfix">
            <Input
              type="text"
              name="blockTileTextField"
              className="blockTileTextField"
              label="Block Name"
              value={blockTileValue}
              onChange={e => checkValidity(e)}
              autoComplete="off"
              formGroupClass={cx(style["mb-0"])}
              maxLength={maxLength}
            />
            <div className={cx(style["d-flex"], style["justify-content-end"])}>{`${charCount}/${maxLength}`}</div>
          </div>
        </div>

        <Button type="button" color="primary" onClick={applyBlockTitle}>
          Save
        </Button>
      </Form>
    </>
  );
};
BlockTileModal.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
};

export default BlockTileModal;
